import { GlowButton, Corners } from "@/components/ui-kit";
import { ASSETS } from "@/config";

const NotFoundPage = () => (
  <div data-testid="not-found-page" className="relative min-h-screen flex items-center justify-center overflow-hidden scanlines px-5">
    <div className="absolute inset-0 grid-bg" aria-hidden="true" />
    <div className="absolute inset-0" aria-hidden="true">
      <img src={ASSETS.commandBg} alt="" className="w-full h-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-gradient-to-b from-arc-black/80 to-arc-black" />
    </div>
    <div className="relative text-center max-w-xl">
      <div className="hud-panel relative inline-block px-10 py-8 mb-8 overflow-hidden">
        <Corners />
        <div className="absolute inset-x-0 h-px bg-gradient-to-r from-transparent via-arc-cyan/70 to-transparent anim-sweep" aria-hidden="true" />
        <img src={ASSETS.logo} alt="ARCMECH" className="w-32 h-auto mx-auto mb-4 anim-float" />
        <div className="font-mono text-[10px] tracking-[0.35em] text-arc-electric">SIGNAL LOST // NODE UNREACHABLE</div>
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-arc-white uppercase">404 — Machine Not Found</h1>
      <p className="mt-4 text-sm sm:text-base text-arc-silver/60">The requested node does not exist in the ARCMECH network.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <GlowButton to="/" testId="notfound-return" cursor="OPEN">RETURN TO NETWORK</GlowButton>
        <GlowButton to="/terminal" variant="ghost" testId="notfound-terminal" cursor="INPUT">OPEN TERMINAL</GlowButton>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
